import {React, useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import UseMediaQuery from "./UseMediaQuery";

function Category()
{
    const [categories, setCategories] = useState([
        { id: 10, name: "گردنبند"},
        { id: 23, name: "چوکر" },
        { id: 17, name: "دستبند" },
        { id: 11, name: "گوشواره" },
        { id: 15, name: "انگشتر" },
        { id: 21, name: "آویز" },
        { id: 14, name: "پابند" },
        { id: 22, name: "مردانه" },
        { id: 115, name: "کودک" },
        { id: 101, name: "قفل" },
    ]); // مقداردهی اولیه با داده‌های غیرواقعی
    const isMobile = UseMediaQuery("(max-width: 768px)");

    useEffect(() => {
        
    }, []);
    
    return(
        <div className="category-section d-grid mt-4">
             {categories.map((category, index) => (
                <Link to={`/${category.id}-${category.name}`} className="category-box g-col-2 d-flex flex-column align-items-center rounded-3 justify-content-center" key={index}>
                    <img src={isMobile?require(`../img/category/m_thumnail_${index+1}.png`):require(`../img/category/thumnail_${index+1}.png`)}></img>
                    <span>{category.name}</span>
                </Link>
            ))}
        </div>
    );
}
export default Category;